import React from "react";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import {initDeepLinkData} from "../../utilities/sdk-doc-utils";
import EntityHandler from "js/utilities/entity-handler"

export default React.createClass({

  // My thought here is that all of the editable textfields on the account page should render as <span> elements, then when clicked change to <input>
  // This is a nice elegant way to clean up the interface instead of having forms everywhere
  // But, for the sake of expediency, we're just going to render them as forms

  componentWillMount() {
    this.setState({
      value: this.props.value,
      modified: false,
      updating: false,
      successfulUpdate: false
    })
  },

  render(){
    return(
      <div className="form-row">
        <label>{this.props.label}: </label>
        <span className="form-value">
          <input type="text" defaultValue={this.state.value} onChange={this.updateValue} disabled={!this.props.canEdit} />
          { (this.props.canEdit && this.state.modified) &&
          <button onClick={this.saveUpdate} className="account-form-submit" name="Save">
            <FontAwesome className="green" name="pencil-square" title="Click to save" />
          </button>
          }

          { this.state.updating &&
          <button>
            <FontAwesome name="circle-o-notch" className="form-icon fa-spin processing" />
          </button>
          }

          { this.state.successfulUpdate &&
          <button>
            <FontAwesome name="check" className="green form-icon" />
          </button>
          }
        </span>
      </div>
    );
  },

  updateValue(e){
    this.setState({
      value: e.target.value,
      modified: true
    });
  },

  // Not that this is a -lot- of code, but would be nice if we didn't have to duplicate this for every field type...
  // But, I don't believe there is object inheritance in React so not sure the best way to make this dry
  saveUpdate(e) {
    EntityHandler.updateEntityProperty(
      this.props.entityType,
      this.props.entityId,
      this.props.field,
      this.state.value,
      this.entityUpdated
    );
    this.setState({
      modified: false,
      updating: true
    })
  },

  entityUpdated(success){
    this.setState({
      updating: false,
      successfulUpdate: success
    });

    setTimeout(() => {
      this.setState(() => ({successfulUpdate: false}))
    }, 2000);

  },


});



// WEBPACK FOOTER //
// ./src/js/components/account/account-form-textfield.jsx